module.exports = {
  title: '提示文案',
  route: {
    path: '/admin-system-manage',
    children: {
      path: 'copywriting-tips',
    },
  },
};
